export const styles = {
  palette: {
    primary: { main: '#503E9D', dark: '#443485', typography: '#FFFFFF' },
    secondary: {
      main: '#FCD561',
      dark: '#E6C257',
      typography: '#000000',
      typographyMain: '#FB6D3A'
    },
    default: {
      success: '#44AF69',
      error: '#F8333C',
      info: '#2B9EB3',
      warning: '#F66800'
    },
    gray: {
      main: '#BBBBBB',
      dark: '#A3A3A3',
      light: '#DDDDDD'
    }
  },
  space: [],
  sizes: {
    fit: '100%',
    xlarge: 220,
    large: 170,
    regular: 115,
    small: 90,
    xsmall: 40
  },
  colors: {
    black: '#000'
  }
}
